import GuestService from "../services/Guest/guestService";
const guestService = new GuestService();

export async function guestLogout(router) {
  // 1. Backend'e log gönder
  // await axios.post("/api/auth/logout"); // Minimal API logout endpoint
  let result = await guestService.LogoutGuest();
  if (result.data.success === true) {
    // 2. Localstorage temizle
    // localStorage.clear();

    // 3. Login sayfasına yönlendir (layout, router guard tarafından otomatik set edilir)
    router.push({ name: "GuestLogin" });
  } else {
    console.error("Logout failed:", result.data.message);
    // Hata durumunda kullanıcıya bilgi verilebilir
  }
}
